module.exports = __webpack_public_path__ + "static/img/img_cabinet.a1e160cb.png";